var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 15.1622V13.7027C15.25 12.7623 16.0335 12 17 12H19C19.9665 12 20.75 12.7623 20.75 13.7027V15.1622H21C21.5523 15.1622 22 15.5978 22 16.1351V20.027C22 20.5644 21.5523 21 21 21H15C14.4477 21 14 20.5644 14 20.027V16.1351C14 15.5978 14.4477 15.1622 15 15.1622H15.25ZM16.75 13.7027V15.1622H19.25V13.7027C19.25 13.5684 19.1381 13.4595 19 13.4595H17C16.8619 13.4595 16.75 13.5684 16.75 13.7027Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V7.25H2V5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.75V15C2 16.1046 2.89543 17 4 17H12.5V16.1351C12.5 15.2013 13.0122 14.4158 13.75 13.9944V13.7027C13.75 11.8954 15.2441 10.5 17 10.5H19C20.3265 10.5 21.5036 11.2964 22 12.4652V8.75H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardLock);
export default __webpack_public_path__ + "static/media/credit-card-lock.d50eb5ea033cf3bedf7399c4cce8f1ae.svg";
export { ForwardRef as ReactComponent };